import { Component, OnInit } from '@angular/core';
import { FacultyPortalService } from 'src/app/services/FacultyPortal/faculty-portal.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import * as moment from 'moment'

@Component({
  selector: 'app-home-work',
  templateUrl: './home-work.component.html',
  styleUrls: ['./home-work.component.css']
})

export class HomeWorkComponent implements OnInit {

  CurrentDate = new Date();
  Heading = "Add";
  Submitted = false;
  SelectFileUpload: any;
  TeacherHomeWorkList = [];
  StudentHomeWorkList = [];
  ClassList = [];
  CourseList = [];
  SectionList = [];
  AssignmentTypeList = [];
  StaffList = [];

  constructor(private facultyportalservice: FacultyPortalService, private lookupservice: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }

  HomeWorkModel = {
    HomeWorkID: 0,
    ClassID: 0,
    SectionID: 0,
    CourseID: 0,
    StudentID: 0,
    AssignmentTypeID: 0,
    AssignmentDate: '',
    SubmissionDate: '',
    HomeWorkTitle: '',
    Description: '',
    IsActive: true,
    TearcherComment: '',
    StudentHomeWorkID:0,
  };


  Clear() {
    this.Submitted = false;
    this.Heading = "Add";
    this.HomeWorkModel.HomeWorkID = 0;
    this.HomeWorkModel.StudentID = 0;
    this.HomeWorkModel.ClassID = 0;
    this.HomeWorkModel.CourseID = 0;
    this.HomeWorkModel.SectionID = 0;
    this.HomeWorkModel.AssignmentTypeID = 0;
    this.HomeWorkModel.AssignmentDate = '';
    this.HomeWorkModel.SubmissionDate = '';
    this.HomeWorkModel.HomeWorkTitle = '';
    this.HomeWorkModel.Description = '';
    this.SelectFileUpload = '';
    this.HomeWorkModel.IsActive = false;

  }

  selectFileUpload(file) {
    this.SelectFileUpload = file[0];
  };


  ResetSearch() {
    if(this.StaffList.length!=2){
      this.SearchModel.StaffID = 0;
    }
    
    this.SearchModel.SectionID = 0;
    this.SearchModel.ClassID = 0;
    this.SearchModel.FromDate = '';
    this.SearchModel.ToDate = '';
  }


  SearchModel = {
    ClassID: 0,
    SectionID: 0,
    StaffID: 0,
    FromDate: '',
    ToDate: '',

  }

  ValidateDropdown() {
    return this.HomeWorkModel.ClassID == 0 || this.HomeWorkModel.SectionID == 0 || this.HomeWorkModel.AssignmentTypeID == 0 ;

  };


  SaveTeacherHomeWork() {
    this.Submitted = true;
    if (!this.ValidateDropdown()) {
      this.spinnerService.show();
      this.HomeWorkModel.AssignmentDate = this.HomeWorkModel.AssignmentDate != null && this.HomeWorkModel.AssignmentDate != '' ? moment(this.HomeWorkModel.AssignmentDate).format('DD-MMM-YYYY') : '';
      this.HomeWorkModel.SubmissionDate = this.HomeWorkModel.SubmissionDate != null && this.HomeWorkModel.SubmissionDate != '' ? moment(this.HomeWorkModel.SubmissionDate).format('DD-MMM-YYYY') : '';
      this.facultyportalservice.SaveTeacherHomeWork(JSON.stringify(this.HomeWorkModel), this.SelectFileUpload).subscribe((data: any) => {
        this.spinnerService.hide();
        if (this.HomeWorkModel.HomeWorkID == 0 && data.webResponse.Status) {
          this.Clear();
        }
        this.GetTeacherHomeWorkAdmin();
        this.globalHelper.CheckActionStatus(data);

      });
    }
  }

  GetTeacherHomeWorkAdmin() {
    this.spinnerService.show();
    this.SearchModel.SectionID == null ? 0 : this.SearchModel.SectionID;
    this.SearchModel.ClassID == null ? 0 : this.SearchModel.ClassID;
    this.SearchModel.StaffID == null ? 0 : this.SearchModel.StaffID;
    this.facultyportalservice.GetTeacherHomeWorkAdmin(JSON.stringify(this.SearchModel)).subscribe((data: any) => {
      this.TeacherHomeWorkList = data.TeacherHomeWorkList;
      this.spinnerService.hide();
    });
  };


  SetHomeWorkID(HomeWorkID) {
    this.spinnerService.show();
    this.facultyportalservice.GetSubmitedStudentHomeWork(HomeWorkID).subscribe((data: any) => {
      this.StudentHomeWorkList = data.StudentHomeWorkList;
      this.spinnerService.hide();
    });
  };


  // Active InActive

  MarkActive(item) {
    this.Clear();
    this.HomeWorkModel.HomeWorkID = item.HomeWorkID;
    this.HomeWorkModel.IsActive = item.IsActive == true ? false : true;
    this.facultyportalservice.StudentHomeWorkMarkActive(this.HomeWorkModel.HomeWorkID, this.HomeWorkModel.IsActive).subscribe((data: any) => {
      if (data.webResponse.Status) {
        this.GetTeacherHomeWorkAdmin();
      }
      this.globalHelper.CheckActionStatus(data);
    });
  }

  Edit(obj) {
    this.Heading = "Update";
    this.HomeWorkModel.HomeWorkID = obj.HomeWorkID;
    this.HomeWorkModel.ClassID = obj.ClassID;
    this.GetSection();
    this.HomeWorkModel.SectionID = obj.SectionID;
    this.GetSubject();
    this.HomeWorkModel.CourseID = obj.CourseID;
    this.HomeWorkModel.AssignmentTypeID = obj.AssignmentTypeID;
    this.HomeWorkModel.AssignmentDate = moment(obj.AssignmentDate).format('DD-MMM-YYYY');
    this.HomeWorkModel.SubmissionDate = obj.SubmissionDate != null && obj.SubmissionDate != '' ? moment(obj.SubmissionDate).format('DD-MMM-YYYY') : '';
    this.HomeWorkModel.HomeWorkTitle = obj.HomeWorkTitle;
    this.HomeWorkModel.Description = obj.Description;
    this.HomeWorkModel.IsActive = obj.IsActive;

  }

  CommentTeacherHomeWork() {
    this.Submitted = true;
    this.spinnerService.show();
    this.facultyportalservice.CommentTeacherHomeWork(this.HomeWorkModel.StudentID, this.HomeWorkModel.HomeWorkID, this.HomeWorkModel.TearcherComment).subscribe((data: any) => {
      // this.SetHomeWorkID(this.HomeWorkModel.HomeWorkID);
     
      this.HomeWorkModel.TearcherComment = '';
      this.globalHelper.CheckActionStatus(data);
      this.HomeWorkModel.HomeWorkID=this.HomeWorkID;
      // this.GetStudentHomeWorkFile()
      this.spinnerService.hide();
    });

  }

  SetID(obj) {
    // alert(obj.StudentHomeworkID);
    this.HomeWorkModel.StudentID = obj.StudentID;
    this.HomeWorkModel.HomeWorkID = obj.StudentHomeworkID;
  }

  ngOnInit() {
    this.GetClass();
    this.GetAssignmentType();
    this.GetStaff();
  }

  GetClass() {
    this.lookupservice.GetLookupsList('LPClass', '').subscribe((data: any) => {
      this.ClassList = data.LookupItems;
    });

  };

  GetSection() {
    this.CourseList = [];
    this.SectionList = [];
    this.HomeWorkModel.CourseID = 0;
    this.HomeWorkModel.SectionID = 0;
    var itembo = {
      'ItemId': this.HomeWorkModel.ClassID
    }
    this.lookupservice.GetLookupsList('LPSection', JSON.stringify(itembo)).subscribe((data: any) => {
      this.SectionList = data.LookupItems;
    });

  };

  GetSectionSearch() {
    this.SearchModel.SectionID = 0;
    var itembo = {
      'ItemId': this.SearchModel.ClassID
    }
    this.lookupservice.GetLookupsList('LPSection', JSON.stringify(itembo)).subscribe((data: any) => {
      this.SectionList = data.LookupItems;
      this.SearchModel.SectionID = 0;
    });

  };

  GetAssignmentType() {
    this.lookupservice.GetLookupsList('AssignmentType', '').subscribe((data: any) => {
      this.AssignmentTypeList = data.LookupItems;

    });

  };

  GetStaff() {
    this.lookupservice.GetLookupsList('StaffName', '').subscribe((data: any) => {
      this.StaffList = data.LookupItems;
      if(this.StaffList!=null && this.StaffList.length==2){
        this.SearchModel.StaffID=this.StaffList[1].ItemId;
      }

    });

  };

  GetSubject() {
    var itembo = {
      ItemId: this.HomeWorkModel.ClassID,
      ItemId1: this.HomeWorkModel.SectionID,
    }
    if (this.HomeWorkModel.SectionID != null) {
      this.lookupservice.GetLookupsList('LPSubject', JSON.stringify(itembo)).subscribe((data: any) => {
        this.CourseList = data.LookupItems;
       
      });
    }
  };
  StudentHomeWorkFileList:any;
  GetStudentHomeWorkFile  () {
      this.facultyportalservice.GetStudentHomeWorkFile(JSON.stringify( this.HomeWorkModel)).subscribe((response: any) => {
          this.StudentHomeWorkFileList = response.StudentHomeWorkFileList;
          this.globalHelper.CheckActionStatus(response);
          this.spinnerService.hide();
      });
  };
  HomeWorkID:any;
  StudentID:any;
  SetHomework (obj) {
    this.HomeWorkID=obj.HomeWorkID;
    this.StudentID=obj.StudentID;
    this.HomeWorkModel.HomeWorkID = obj.HomeWorkID;  
    this.HomeWorkModel.StudentID = obj.StudentID; 
    this.GetStudentHomeWorkFile();
  }
}
